<template>
    <div class="embryo-preview" :class="{ selected: isSelected }" @click="selectEmbryo">
        <div class="embryo-latest-image">
            <img :src="embryo.lastImageUrl" alt="" />
            <well-status-overlay class="rounded-top-lg" :well="embryo" />
        </div>

        <div class="details">
            <div class="slide-well" :title="$translate('well_number')">
                <span :title="$translate('slide')">{{ embryo.slide.esId }}</span>
                /
                <span :title="$translate('well')">{{ embryo.esId }}</span>
            </div>

            <div :title="$translate('last_developmental_event')" class="latest-event">
                <span class="label">{{ $translate('event') }}</span>
                <span class="value">
                    {{ $translate(embryo.latestEvent && embryo.latestEvent.systemName) }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import WellStatusOverlay from '../common/WellStatusOverlay'

export default {
    name: 'EmbryoPreview',
    components: { WellStatusOverlay },
    props: {
        embryo: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            selectedEmbryoId: state => state.patient.selectedEmbryoId
        }),
        isSelected() {
            return this.embryo._id === this.selectedEmbryoId
        }
    },
    methods: {
        selectEmbryo() {
            if (this.isSelected) return

            const { _id } = this.embryo

            this.$router.push({ query: { ...this.$route.query, embryo: _id } })
            this.$store.commit('patient/selectedEmbryoId', _id)
        }
    }
}
</script>

<style lang="scss" scoped>
.embryo-preview {
    position: relative;
    padding: 10px;
    font-size: 12px;
    border-radius: 2px;
    background-color: $dark-2;

    @media screen and #{$new-break2close} {
        width: 120px;
        margin: 5px;
    }
    @media screen and #{$new-break3open} {
        width: 100%;
        margin: 5px 0;
    }

    .embryo-latest-image {
        position: relative;
        border-radius: 6px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .details {
        color: $light;
        display: flex;
        flex-wrap: wrap;

        .slide-well {
            width: 100%;
            overflow-wrap: break-word;
        }

        .latest-event .value {
            color: $light-3;
            font-weight: 600;
        }

        @media screen and #{$new-break2close} {
            flex-direction: column;
        }
        @media screen and #{$new-break3open} {
            flex-direction: row;

            .latest-event {
                margin-left: auto;
            }
        }
    }

    &.selected {
        border: solid 1px $pink;
    }
}
</style>
